import { __assign } from "tslib";
import React from 'react';
import { SplitContext, INITIAL_CONTEXT } from './SplitContext';
import { ERROR_UC_NO_USECONTEXT } from './constants';
import { getSplitSharedClient, checkHooks, initAttributes } from './utils';
/**
 * 'useSplitClient' is a hook that returns an Split Context object with the client and its status corresponding to the provided key and trafficType.
 * It uses the 'useContext' hook to access the context, which is updated by SplitFactory and SplitClient components in the hierarchy of components.
 *
 * @return A Split Context object
 * @see {@link https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#advanced-instantiate-multiple-sdk-clients}
 */
export function useSplitClient(key, trafficType, attributes) {
    if (!checkHooks(ERROR_UC_NO_USECONTEXT))
        return INITIAL_CONTEXT;
    var context = React.useContext(SplitContext);
    var factory = context.factory, client = context.client;
    if (key && factory) {
        client = getSplitSharedClient(factory, key, trafficType);
    }
    initAttributes(client, attributes);
    return client === context.client ? context : __assign(__assign(__assign({}, context), { client: client }), client.__getStatus());
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-react/es/useSplitClient.js
// module id = 2006
// module chunks = 25